export const PaymentStatuses = {
  created: 'Created',
  confirmed: 'Confirmed'
} as const
